import React, { useCallback, useState } from 'react';
import { bool, string, number } from 'prop-types';
import { Trans } from '@lingui/macro';
import { useDispatch } from 'redux-react-hook';
import { Link } from '@reach/router';
import { linkTo } from 'utils/links';

// Redux
import { postComment } from 'store/modules/comments/actions';

// Components
import Button from 'components/Button';
import TextField from 'components/TextField';

const textfieldStyles = { minHeight: 200 };

export default function CommentForm({ model, id, isLoggedIn }) {
  const [saving, setSaving] = useState(false);
  const [comment, setComment] = useState({ title: '', body: '' });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const onChange = useCallback((event) => {
    setComment({
      ...comment,
      [event.target.name]: event.target.value,
    });
  }, [comment]);
  const onSendComment = useCallback(() => {
    setSaving(true);
    dispatch(postComment(model, id, comment))
      .then(() => {
        setSaving(false);
        setErrors({});
        setComment({ title: '', body: '' })
      })
      .catch((response) => {
        setSaving(false);
        setErrors(response.data.errors || {});
      });
  }, [model, id, comment]);

  if (isLoggedIn) {
    return (
      <div className="mt-8 mb-32 lg:w-3/4 xl:w-4/6">
        <h2 className="text-secondary text-xl mb-8"><Trans>Leave a comment</Trans></h2>
        <TextField
          name="title"
          label="Title"
          onChange={onChange}
          value={comment.title}
          errors={errors.title}
          className="mb-4"
        />
        <TextField
          name="body"
          label="Comment"
          onChange={onChange}
          value={comment.body}
          multiline
          className="mb-4"
          style={textfieldStyles}
          errors={errors.body}
        />
        <Button loading={saving} onClick={onSendComment}><Trans>Send</Trans></Button>
      </div>
    );
  }

  return (
    <div className="mt-8 mb-32 lg:w-3/4 xl:w-4/6">
      <h2 className="text-secondary text-xl"><Trans>Leave a comment</Trans></h2>
      <p className="text-secondary">Commenting is disabled for visitors. <Trans><Link to={linkTo('/auth/sign-in')} className="text-default hover:underline">Sign In</Link> to leave a comment.</Trans></p>
    </div>
  );
}

CommentForm.propTypes = {
  model: string,
  id: number,
  isLoggedIn: bool,
};

CommentForm.defaultProps = {
  isLoggedIn: true,
};